import { render, staticRenderFns } from "./paginationComp.vue?vue&type=template&id=07778aa3"
import script from "./paginationComp.vue?vue&type=script&lang=js"
export * from "./paginationComp.vue?vue&type=script&lang=js"
import style0 from "./paginationComp.vue?vue&type=style&index=0&id=07778aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports